import * as IF from "infrontjs";
import { getStats, resetStats } from '../data/stats.js';
import { RANKS, getRankForLevel } from '../data/ranks.js';
import { trackPageView } from '../data/analytics.js';

const BACK_SVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6 L9 12 L15 18"/></svg>`;
const STAR_SVG = `<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.8 L14.6 8.9 L21.1 9.6 L16.2 13.9 L17.7 20.3 L12 16.9 L6.3 20.3 L7.8 13.9 L2.9 9.6 L9.4 8.9 Z"/></svg>`;

const ICON_CLEARED  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M7 12 L11 16 L17 8"/></svg>`;
const ICON_DEFUSED  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="6"/><path d="M12 4 V7"/><path d="M5 7 L7 9"/><path d="M19 7 L17 9"/><path d="M9 11 H10"/></svg>`;
const ICON_TIME     = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9 V13 L14.5 14.5"/><path d="M9 3 H15"/></svg>`;
const ICON_GAMEOVER = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9 9 L15 15"/><path d="M15 9 L9 15"/></svg>`;
const ICON_SUCCESS  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17 L9 11 L13 15 L21 7"/><path d="M15 7 H21 V13"/></svg>`;
const ICON_FIRSTTRY = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 L7 12 H11 L9 21 L17 10 H13 L15 3 Z"/></svg>`;
const ICON_AVGTIME  = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12 H7"/><path d="M17 12 H21"/><circle cx="12" cy="12" r="5"/><path d="M12 9 V12 L14 13.5"/></svg>`;
const ICON_WARN     = `<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9 V13"/><circle cx="12" cy="16.5" r="0.6" fill="currentColor"/><path d="M10.3 3.6 L2.5 17 a2 2 0 0 0 1.7 3 H19.8 a2 2 0 0 0 1.7 -3 L13.7 3.6 a2 2 0 0 0 -3.4 0 Z"/></svg>`;
const ICON_TRASH    = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6 H21"/><path d="M8 6 V4 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 v2"/><path d="M5 6 L6 20 a2 2 0 0 0 2 2 h8 a2 2 0 0 0 2 -2 L19 6"/></svg>`;
const ICON_RESET    = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12 a 9 9 0 1 0 3-6.7"/><path d="M3 3 V 7 H 7"/></svg>`;
const ICON_CHECK_LG = `<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5 L10 17.5 L19 7.5"/></svg>`;
const ICON_CHECK_SM = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12 L10 18 L20 6"/></svg>`;


function formatHMS( totalSec )
{
    const t = Math.max( 0, Math.floor( totalSec ) );
    const h = Math.floor( t / 3600 );
    const m = Math.floor( ( t % 3600 ) / 60 );
    const s = t % 60;
    if ( h > 0 ) return `${ h }h ${ String( m ).padStart( 2, '0' ) }m`;
    if ( m > 0 ) return `${ m }m ${ String( s ).padStart( 2, '0' ) }s`;
    return `${ s }s`;
}

function formatBig( n )
{
    const v = Math.max( 0, Math.floor( n ) );
    if ( v >= 1000000 ) return ( v / 1000000 ).toFixed( v >= 10000000 ? 0 : 1 ) + 'M';
    if ( v >= 10000 )   return ( v / 1000 ).toFixed( v >= 100000 ? 0 : 1 ) + 'k';
    return String( v );
}

function formatPct( num, den )
{
    if ( !den ) return '—';
    const p = num / den * 100;
    return ( p >= 99.95 ? '100' : p.toFixed( 1 ) ) + '%';
}

function formatAvg( totalSec, n )
{
    if ( !n ) return '—';
    return formatHMS( Math.round( totalSec / n ) );
}

function escape( s )
{
    return String( s ).replace( /[&<>"']/g, ch => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ ch ]
    ));
}

function statCard( { id, icon, label, value, sub, accent, big } )
{
    const cls = 'pm-stat'
        + ( accent ? ' pm-stat--accent' : '' )
        + ( big ? ' pm-stat--big' : '' );
    return `
        <div class="${ cls }"${ id ? ` id="${ id }"` : '' }>
            <div class="pm-stat__icon">${ icon }</div>
            <div class="pm-stat__body">
                <div class="pm-stat__label">${ escape( label ) }</div>
                <div class="pm-stat__value">${ escape( value ) }</div>
                ${ sub ? `<div class="pm-stat__sub">${ escape( sub ) }</div>` : '' }
            </div>
        </div>`;
}

export class StatState extends IF.State
{
    static ID = 'stats';
    static ROUTE = '/stats';

    async enter()
    {
        trackPageView( 'StatState', '/stats' );

        const appEl = document.getElementById( 'app' );
        const gameEl = document.getElementById( 'game-container' );
        appEl.classList.add( 'active' );
        gameEl.classList.remove( 'active' );

        this._render();
    }

    _render()
    {
        this._cancelAnim();
        const s = getStats();
        // Rank progression: rankProgress is 0..1 within the current rank;
        // nextRankName falls back to the current rank at the top tier.
        const cleared = Math.max( 0, s.currentLevel - 1 );
        const rankInfo = getRankForLevel( cleared );
        const nextRank = RANKS[ rankInfo.rankIndex + 1 ] || rankInfo.rank;
        const rankPct = Math.round( rankInfo.progress * 100 );

        // Success ratio uses levels actually completed (currentLevel - 1), since
        // the current level is in progress and hasn't been cleared yet.
        const successWins     = Math.max( 0, s.currentLevel - 1 );
        const successPctText  = formatPct( successWins, s.levelsStarted );
        const firstTryPctText = formatPct( s.firstTryWins, s.levelsStarted );

        const totalsHtml = [
            statCard({
                id: 'st-cleared',
                icon: ICON_CLEARED, label: 'Fields cleared',
                value: formatBig( s.clearedFields ),
                sub: `${ s.clearedFields.toLocaleString() } cells`,
            }),
            statCard({
                id: 'st-defused',
                icon: ICON_DEFUSED, label: 'Mines defused',
                value: formatBig( s.minesDefused ),
            }),
            statCard({
                id: 'st-time',
                icon: ICON_TIME, label: 'Total play time',
                value: formatHMS( s.totalPlayTime ),
            }),
            statCard({
                id: 'st-gameovers',
                icon: ICON_GAMEOVER, label: 'Game overs',
                value: formatBig( s.totalGameOvers ),
            }),
        ].join( '' );

        const performanceHtml = [
            statCard({
                id: 'st-success',
                icon: ICON_SUCCESS, label: 'Success ratio',
                value: successPctText,
                sub: `${ successWins } / ${ s.levelsStarted } starts`,
                accent: true,
            }),
            statCard({
                id: 'st-firsttry',
                icon: ICON_FIRSTTRY, label: 'First-try ratio',
                value: firstTryPctText,
                sub: `${ s.firstTryWins } / ${ s.levelsStarted } starts`,
                accent: true,
            }),
            statCard({
                id: 'st-avg',
                icon: ICON_AVGTIME, label: 'Avg time / level',
                value: formatAvg( s.totalPlayTime, s.levelsWon ),
                sub: `across ${ s.levelsWon } wins`,
                big: true,
            }),
        ].join( '' );

        this.app.view.renderHtml( this.app.container, `
            <div class="pm-stats">
                <header class="pm-stats__top">
                    <button class="pm-stats__back" id="pm-stats-back" type="button" aria-label="Back">${ BACK_SVG }</button>
                    <div class="pm-stats__title">Stats</div>
                    <div class="pm-stats__topSpacer" aria-hidden="true"></div>
                </header>

                <div class="pm-stats__scroll">
                    <section class="pm-stats__hero">
                        <div class="pm-stats__heroLevel">
                            <div class="pm-stats__heroLabel">Current level</div>
                            <div class="pm-stats__heroValue">${ String( s.currentLevel ).padStart( 3, '0' ) }</div>
                            <div class="pm-stats__heroSub">of 999</div>
                        </div>
                        <div class="pm-stats__heroRank">
                            <div class="pm-stats__heroLabel">Rank</div>
                            <div class="pm-stats__heroRankRow">
                                <span class="pm-stats__star">${ STAR_SVG }</span>
                                <span class="pm-stats__rankName">${ escape( rankInfo.rank.name ) }</span>
                            </div>
                            <div class="pm-stats__rankBar" aria-label="${ rankPct }% to ${ escape( nextRank.name ) }">
                                <div class="pm-stats__rankFill" style="width: ${ rankPct }%"></div>
                            </div>
                            <div class="pm-stats__rankCaption">
                                <span class="pm-stats__rankPctLabel">${ rankPct }%</span>
                                <span> to ${ escape( nextRank.name ) }</span>
                            </div>
                        </div>
                    </section>

                    <section class="pm-stats__group">
                        <h4 class="pm-stats__groupTitle">Totals</h4>
                        <div class="pm-stats__grid">${ totalsHtml }</div>
                    </section>

                    <section class="pm-stats__group">
                        <h4 class="pm-stats__groupTitle">Performance</h4>
                        <div class="pm-stats__grid">${ performanceHtml }</div>
                    </section>

                    <footer class="pm-stats__footer">
                        <button class="pm-stats__reset" id="pm-stats-reset" type="button">
                            ${ ICON_RESET }
                            Reset stats
                        </button>
                        <p class="pm-stats__resetNote">Clears all numbers above. Cannot be undone.</p>
                    </footer>
                </div>

                <div class="pm-confirm" id="pm-stats-confirm" aria-hidden="true">
                    <button class="pm-confirm__scrim" id="pm-stats-confirm-scrim" type="button" aria-label="Cancel" tabindex="-1"></button>
                    <div class="pm-confirm__card" role="dialog" aria-modal="true" aria-labelledby="pm-stats-confirm-title">
                        <div class="pm-confirm__icon">${ ICON_WARN }</div>
                        <h3 class="pm-confirm__title" id="pm-stats-confirm-title">Reset all stats?</h3>
                        <p class="pm-confirm__body">
                            This will clear your totals, ratios and timings.
                            <strong>This action can't be undone.</strong>
                        </p>
                        <div class="pm-confirm__actions">
                            <button class="pm-confirm__cancel" id="pm-stats-confirm-cancel" type="button">Keep stats</button>
                            <button class="pm-confirm__confirm" id="pm-stats-confirm-yes" type="button">
                                ${ ICON_TRASH }
                                Yes, reset
                            </button>
                        </div>
                    </div>
                </div>

                <div class="pm-confirm pm-confirm--success" id="pm-stats-success" aria-hidden="true">
                    <button class="pm-confirm__scrim" id="pm-stats-success-scrim" type="button" aria-label="Close" tabindex="-1"></button>
                    <div class="pm-confirm__card" role="dialog" aria-modal="true" aria-labelledby="pm-stats-success-title">
                        <div class="pm-confirm__icon pm-confirm__icon--ok">${ ICON_CHECK_LG }</div>
                        <h3 class="pm-confirm__title" id="pm-stats-success-title">All clear!</h3>
                        <p class="pm-confirm__body">
                            Your stats have been reset on this device. Every counter is back to zero &mdash; happy defusing.
                        </p>
                        <div class="pm-confirm__actions pm-confirm__actions--single">
                            <button class="pm-confirm__ok" id="pm-stats-success-ok" type="button">
                                ${ ICON_CHECK_SM }
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this._animateStats( s, successWins, rankPct );

        document.getElementById( 'pm-stats-back' ).addEventListener( 'click', () =>
        {
            this.app.router.redirect( '/' );
        });

        const confirmEl = document.getElementById( 'pm-stats-confirm' );
        const openConfirm = () =>
        {
            confirmEl.classList.add( 'is-open' );
            confirmEl.setAttribute( 'aria-hidden', 'false' );
        };
        const closeConfirm = () =>
        {
            confirmEl.classList.remove( 'is-open' );
            confirmEl.setAttribute( 'aria-hidden', 'true' );
        };

        const successEl = document.getElementById( 'pm-stats-success' );
        const openSuccess  = () => { successEl.classList.add( 'is-open' );    successEl.setAttribute( 'aria-hidden', 'false' ); };
        const closeSuccess = () => { successEl.classList.remove( 'is-open' ); successEl.setAttribute( 'aria-hidden', 'true' ); };

        document.getElementById( 'pm-stats-reset' ).addEventListener( 'click', openConfirm );
        document.getElementById( 'pm-stats-confirm-cancel' ).addEventListener( 'click', closeConfirm );
        document.getElementById( 'pm-stats-confirm-scrim' ).addEventListener( 'click', closeConfirm );
        document.getElementById( 'pm-stats-confirm-yes' ).addEventListener( 'click', () =>
        {
            resetStats();
            closeConfirm();
            this._render();
            // _render rebuilt the DOM, so re-grab the success element.
            const newSuccess = document.getElementById( 'pm-stats-success' );
            newSuccess.classList.add( 'is-open' );
            newSuccess.setAttribute( 'aria-hidden', 'false' );
        });

        document.getElementById( 'pm-stats-success-ok'    ).addEventListener( 'click', closeSuccess );
        document.getElementById( 'pm-stats-success-scrim' ).addEventListener( 'click', closeSuccess );
    }

    _cancelAnim()
    {
        if ( this._rafId )
        {
            cancelAnimationFrame( this._rafId );
            this._rafId = null;
        }
    }

    _animateStats( s, successWins, rankPct )
    {
        const specs = [
            { sel: '.pm-stats__heroValue',    render: p => String( Math.max( 0, Math.round( s.currentLevel * p ) ) ).padStart( 3, '0' ) },
            { sel: '.pm-stats__rankFill',     style: 'width', render: p => `${ rankPct * p }%` },
            { sel: '.pm-stats__rankPctLabel', render: p => `${ Math.round( rankPct * p ) }%` },

            { sel: '#st-cleared .pm-stat__value',   render: p => formatBig( s.clearedFields * p ) },
            { sel: '#st-cleared .pm-stat__sub',     render: p => `${ Math.max( 0, Math.round( s.clearedFields * p ) ).toLocaleString() } cells` },
            { sel: '#st-defused .pm-stat__value',   render: p => formatBig( s.minesDefused * p ) },
            { sel: '#st-time .pm-stat__value',      render: p => formatHMS( s.totalPlayTime * p ) },
            { sel: '#st-gameovers .pm-stat__value', render: p => formatBig( s.totalGameOvers * p ) },

            { sel: '#st-success .pm-stat__value', render: p =>
            {
                if ( !s.levelsStarted ) return '—';
                const pct = ( successWins / s.levelsStarted ) * p * 100;
                return ( pct >= 99.95 ? '100' : pct.toFixed( 1 ) ) + '%';
            }},
            { sel: '#st-success .pm-stat__sub', render: p =>
                `${ Math.round( successWins * p ) } / ${ Math.round( s.levelsStarted * p ) } starts` },

            { sel: '#st-firsttry .pm-stat__value', render: p =>
            {
                if ( !s.levelsStarted ) return '—';
                const pct = ( s.firstTryWins / s.levelsStarted ) * p * 100;
                return ( pct >= 99.95 ? '100' : pct.toFixed( 1 ) ) + '%';
            }},
            { sel: '#st-firsttry .pm-stat__sub', render: p =>
                `${ Math.round( s.firstTryWins * p ) } / ${ Math.round( s.levelsStarted * p ) } starts` },

            { sel: '#st-avg .pm-stat__value', render: p =>
            {
                if ( !s.levelsWon ) return '—';
                const avg = ( s.totalPlayTime / s.levelsWon ) * p;
                return formatHMS( Math.round( avg ) );
            }},
            { sel: '#st-avg .pm-stat__sub', render: p => `across ${ Math.round( s.levelsWon * p ) } wins` },
        ];

        const apply = ( p ) =>
        {
            for ( const spec of specs )
            {
                const el = document.querySelector( spec.sel );
                if ( !el ) continue;
                const val = spec.render( p );
                if ( spec.style ) el.style[ spec.style ] = val;
                else el.textContent = val;
            }
        };

        apply( 0 );

        const start = performance.now();
        const tick = ( now ) =>
        {
            const t = Math.min( 1, ( now - start ) / 1000 );
            const p = 1 - Math.pow( 1 - t, 3 );
            apply( p );
            this._rafId = ( t < 1 ) ? requestAnimationFrame( tick ) : null;
        };
        this._rafId = requestAnimationFrame( tick );
    }

    async exit()
    {
        this._cancelAnim();
        this.app.container.innerHTML = '';
        document.getElementById( 'app' ).classList.remove( 'active' );
    }
}
